
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useRef, useEffect, useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import ReCAPTCHA from 'react-google-recaptcha';
// components
import { Grid, Input, Message, Checkbox } from '@design-system-coopeuch/web';
import SkeletonInputTextAndLabel from '../../molecules/SkeletonInputTextAndLabel/SkeletonInputTextAndLabel';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import Skeleton from '../../atoms/Skeleton/Skeleton';
import { useModal } from '../../../hooks/useModal';
import ContentSerialNumber from '../../molecules/ContentSerialNumber';
import ItemValidation from '../../molecules/ItemValidation/ItemValidation';
import Modal from '../../organisms/Modal/Modal';
import Survey from '../../../containers/Survey/Survey';
import { personalDataActions } from '../../../../application/actions/personalData';
// assets
import iconQuestion from '../../../assets/img/icon-question.svg';
// styles
import {
  StyledWrapperInput,
  StyledButton,
  WrapperCheckboxs,
  WrapperCheckbox,
  StyledWrapperMessage,
} from '../../../assets/styles/styles';
// constans
import { constants } from '../../../../domain/constants';

const MAX_RUT_WITH_OR_WITHOUT_DASH = constants.MAX_RUT_WITH_OR_WITHOUT_DASH;
const MAX_SERIAL_NUMBER = constants.MAX_SERIAL_NUMBER;
const tokenKey = process.env.REACT_APP_RECAPTCHA_KEY;

/** ------------------------------- Helpers puros -------------------------------- */
/* istanbul ignore next */
function getRutAssistText(rut) {
  return rut.errors.length > 0 ? rut.errors : [{ text: 'Sin puntos', type: 'assist' }];
}
/* istanbul ignore next */
function getSerialAssistText(serialNumber, badSerialNumber) {
  if (serialNumber.value.trim() === '') return [{ text: 'Sin puntos', type: 'assist' }];
  if (badSerialNumber) return [{ text: 'El número ingresado es incorrecto', type: 'error' }];
  if (serialNumber.errors.length > 0) return serialNumber.errors;
  return [{ text: 'Sin puntos', type: 'assist' }];
}
/* istanbul ignore next */
function getSerialError(serialNumber, badSerialNumber) {
  return serialNumber.errors.length > 0 || badSerialNumber;
}

/** --------------------------- Subcomponentes (memo) ---------------------------- */
/* istanbul ignore next */
const ValidatedBanner = memo(function ValidatedBanner() {
  return (
    <Grid row className="m-0 p-0 w-100">
      <StyledWrapperMessage>
        <Message
          className="w-100"
          type="info"
          description="Tu cédula de identidad ha sido validada con éxito."
          closer={null}
        />
      </StyledWrapperMessage>
    </Grid>
  );
});
/* istanbul ignore next */
const RutField = memo(function RutField({ rut, isLoadingValidatePersonalData, onRutChange }) {
  if (isLoadingValidatePersonalData) {
    return (
      <Grid className="p-0 pr-md-4 mb-4 mb-md-2" col={12} md={4}>
        <SkeletonInputTextAndLabel />
      </Grid>
    );
  }
  /* istanbul ignore next */
  return (
    <Grid
      className={`p-0 pr-md-4 ${isLoadingValidatePersonalData ? 'mb-4 mb-md-2' : 'mb-2 mb-md-0'}`}
      col={12}
      md={4}
    >
      <StyledWrapperInput>
        <Input
          label="RUT"
          value={rut.value}
          maxLength={MAX_RUT_WITH_OR_WITHOUT_DASH}
          assistText={getRutAssistText(rut)}
          onChange={onRutChange}
          error={rut.errors.length > 0}
          autoComplete="new-password"
        />
      </StyledWrapperInput>
    </Grid>
  );
});
/* istanbul ignore next */
const SerialField = memo(function SerialField({
  serialNumber,
  isLoadingValidatePersonalData,
  openModalCedule,
  badSerialNumber,
  onSerialChange,
}) {
  if (isLoadingValidatePersonalData) {
    return (
      <Grid className="p-0 pr-md-4 mb-4 mb-md-2" col={12} md={4}>
        <SkeletonInputTextAndLabel />
      </Grid>
    );
  }
  /* istanbul ignore next */
  return (
    <Grid
      className={`p-0 pr-md-4 ${isLoadingValidatePersonalData ? 'mb-4 mb-md-2' : 'mb-2 mb-md-0'}`}
      col={12}
      md={4}
    >
      <StyledWrapperInput>
        <button
          type="button"
          tabIndex="-1"
          onClick={openModalCedule}
          className="btn-tooltip-label border-0 p-0 m-0 d-flex"
        >
          <img className="img-show-detail" src={iconQuestion} alt="" />
        </button>

        <Input
          label="Nº de serie o documento"
          value={serialNumber.value}
          maxLength={MAX_SERIAL_NUMBER}
          assistText={getSerialAssistText(serialNumber, badSerialNumber)}
          onChange={onSerialChange}
          error={getSerialError(serialNumber, badSerialNumber)}
          autoComplete="new-password"
        />
      </StyledWrapperInput>
    </Grid>
  );
});
/* istanbul ignore next */
const ConsentSection = memo(function ConsentSection({
  isLoadingValidatePersonalData,
  isMobileDevice,
  showIsRequiredPreviredAuthorization,
  previredAuthorization,
  onPreviredChange,
  openModal,
}) {
  if (isLoadingValidatePersonalData) {
    return (
      <Grid className="m-0 p-0 mt-2 d-flex flex-column flex-md-row">
        <Skeleton height="24px" width={isMobileDevice ? '100%' : '680px'} mb={12} />
      </Grid>
    );
  }
  /* istanbul ignore next */
  return (
    <Grid className="m-0 p-0 mt-2 d-flex flex-column flex-md-row">
      <>
        <WrapperCheckboxs>
          <WrapperCheckbox
            validationStatus={
              showIsRequiredPreviredAuthorization && !previredAuthorization.value
                ? 'required'
                : 'default'
            }
            key={shortid.generate()}
          >
            <Checkbox
              id="121212"
              label="Confirmo que leí y estoy de acuerdo con el documento de "
              checked={previredAuthorization.value}
              onChange={onPreviredChange}
            />
          </WrapperCheckbox>
        </WrapperCheckboxs>

        <button
          type="button"
          onClick={openModal}
          className="btn-without-format--red-underline mt-1 mt-md-0 text-color-info"
        >
          Consentimiento del tratamiento de datos.
        </button>
      </>
    </Grid>
  );
});
/* istanbul ignore next */
const RequiredConsentMessage = memo(function RequiredConsentMessage({
  showIsRequiredPreviredAuthorization,
  previredAuthorization,
}) {
  if (!(showIsRequiredPreviredAuthorization && !previredAuthorization.value)) return null;
  return (
    <ItemValidation className="mt-0 ml-0 ml-md-4" type="error">
      Debes confirmar tu consentimiento para continuar
    </ItemValidation>
  );
});
/* istanbul ignore next */
const Captcha = memo(function Captcha({
  tokenKey,
  recaptchaInstance,
  onChangeCaptcha,
  onExpired,
  onErrored,
}) {
  return (
    <ReCAPTCHA
      sitekey={tokenKey}
      ref={recaptchaInstance}
      className="catpcha-main"
      onChange={onChangeCaptcha}
      onExpired={onExpired}
      onErrored={onErrored}
    />
  );
});
/* istanbul ignore next */
const FooterActions = memo(function FooterActions({
  isCompletedCardPersonValidation,
  isLoadingValidatePersonalData,
  tokenCaptcha,
  badSerialNumber,
  onValidatePerson,
}) {
  const disabled =
    !isCompletedCardPersonValidation || isLoadingValidatePersonalData || !tokenCaptcha || badSerialNumber;

  const handleClick = () => {
    if (tokenCaptcha && !badSerialNumber) onValidatePerson();
  };
  /* istanbul ignore next */
  return (
    <Grid
      row
      className="m-0 padding-16 p-md-6 align-items-center justify-content-end border-top border-neutral-alfa-15"
    >
      <Grid col={12} md={4} className="m-0 p-0">
        <StyledButton
          variant="default"
          color="secondary"
          onClick={handleClick}
          className="w-100 d-flex justify-content-center"
          appearanceDisabled={disabled}
        >
          Verificar mi cédula
        </StyledButton>
      </Grid>
    </Grid>
  );
});

/** --------------------------- Componente principal ----------------------------- */
/* istanbul ignore next */
const CardPersonValidation = (props) => {
  const {
    rut,
    serialNumber,
    isValidPerson,
    previredAuthorization,
    showIsRequiredPreviredAuthorization,
    isMobileDevice,
    isCompletedCardPersonValidation,
    isLoadingValidatePersonalData,
    isOpenModalAlreadyMemberRedirection,
    onValidatePerson,
    onChange,
  } = props;
  /* istanbul ignore next */
  const dispatch = useDispatch();
  const validSerialNumber = useSelector((state) => state.entities.personalData);
  const { badSerialNumber } = validSerialNumber;

  const [isOpen, openModal, closeModal] = useModal(false);
  const [isOpenModalCedule, openModalCedule, closeModalCedule] = useModal(false);

  const [tokenCaptcha, setTokenCaptcha] = useState();
  const recaptchaInstance = useRef(null);

  // Handlers
  /* istanbul ignore next */
  const onRutChange = useCallback(
    (value) =>
      onChange({
        field: 'rut',
        property: 'value',
        value,
      }),
    [onChange]
  );
  /* istanbul ignore next */
  const revertStateSerialNumber = useCallback(() => {
    dispatch(personalDataActions.changeStateBadSerial({ stateSerial: false }));
  }, [dispatch]);
  /* istanbul ignore next */
  const onSerialChange = useCallback(
    (value) => {
      onChange({
        field: 'serialNumber',
        property: 'value',
        value,
      });
      if (badSerialNumber) revertStateSerialNumber();
    },
    [onChange, badSerialNumber, revertStateSerialNumber]
  );
  /* istanbul ignore next */
  const onPreviredChange = useCallback(
    (checked) =>
      onChange({
        field: 'previredAuthorization',
        property: 'value',
        value: checked,
      }),
    [onChange]
  );
  /* istanbul ignore next */
  const onChangeCaptcha = useCallback(() => {
    const val = recaptchaInstance.current?.getValue?.();
    if (val) {
      setTokenCaptcha(val);
      sessionStorage.setItem('authToken', val);
    }
  }, []);

  const onExpired = useCallback(() => setTokenCaptcha(null), []);
  const onErrored = useCallback(() => setTokenCaptcha(null), []);
  /* istanbul ignore next */
  useEffect(() => {
    if (!badSerialNumber) return;

    onChange({
      field: 'previredAuthorization',
      property: 'value',
      value: false,
    });

    if (recaptchaInstance.current) recaptchaInstance.current.reset?.();
    setTokenCaptcha(null);
    sessionStorage.removeItem('authToken');
  }, [badSerialNumber, onChange]);

  // Early return cuando ya está validada la persona
  if (isValidPerson) return <ValidatedBanner />;
  /* istanbul ignore next */
  return (
    <>
      <SimpleCard
        contentHeader={<p className="simplecard__title">Para comenzar, verificaremos tu cédula de identidad</p>}
      >
        <Grid className="m-0 padding-16 p-md-6">
          <Grid row className="m-0">
            <RutField
              rut={rut}
              isLoadingValidatePersonalData={isLoadingValidatePersonalData}
              onRutChange={onRutChange}
            />

            <SerialField
              serialNumber={serialNumber}
              isLoadingValidatePersonalData={isLoadingValidatePersonalData}
              openModalCedule={openModalCedule}
              badSerialNumber={badSerialNumber}
              onSerialChange={onSerialChange}
            />
          </Grid>

          <ConsentSection
            isLoadingValidatePersonalData={isLoadingValidatePersonalData}
            isMobileDevice={isMobileDevice}
            showIsRequiredPreviredAuthorization={showIsRequiredPreviredAuthorization}
            previredAuthorization={previredAuthorization}
            onPreviredChange={onPreviredChange}
            openModal={openModal}
          />

          <RequiredConsentMessage
            showIsRequiredPreviredAuthorization={showIsRequiredPreviredAuthorization}
            previredAuthorization={previredAuthorization}
          />

          <Captcha
            tokenKey={tokenKey}
            recaptchaInstance={recaptchaInstance}
            onChangeCaptcha={onChangeCaptcha}
            onExpired={onExpired}
            onErrored={onErrored}
          />
        </Grid>

        <FooterActions
          isCompletedCardPersonValidation={isCompletedCardPersonValidation}
          isLoadingValidatePersonalData={isLoadingValidatePersonalData}
          tokenCaptcha={tokenCaptcha}
          badSerialNumber={badSerialNumber}
          onValidatePerson={onValidatePerson}
        />
      </SimpleCard>

      <Modal isOpen={isOpenModalAlreadyMemberRedirection} unableToClose>
        <Survey type="alreadyMember" />
      </Modal>

      <Modal isOpen={isOpen} closeModal={closeModal} closeClickOutside closeEscKey>
        <section className="d-flex flex-column width-lg-750px h-100">
          <Grid className="p-0 m-0 px-6 py-4 border-bottom border-neutral-alfa-15 flex-0-1-auto">
            <p className="font-size-24 line-height-30 font-weight-bold">Consentimiento del tratamiento de datos</p>
          </Grid>

          <Grid className="p-0 m-0 p-6 d-flex flex-column flex-1-1-auto overflow-auto">
            <p className="font-size-14 line-height-20 mb-2">
              De acuerdo a la Ley 19.628 “Sobre Protección de la Vida Privada”, Coopeuch hará uso de los datos
              personales que nos compartas con finalidades específicas y explicadas en detalle más abajo.
            </p>

            <p className="mb-2 font-size-14 line-height-20 font-weight-bold">Datos personales requeridos:</p>

            <Grid row className="m-0 p-0">
              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 margin-bottom-4 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">Rut</li>
                  <li className="text-color-38 font-size-14 line-height-18">N° Serie Documento</li>
                  <li className="text-color-38 font-size-14 line-height-18">Nombre completo</li>
                  <li className="text-color-38 font-size-14 line-height-18">Profesión u Oficio</li>
                  <li className="text-color-38 font-size-14 line-height-18">Actividad Laboral</li>
                  <li className="text-color-38 font-size-14 line-height-18">Cargo</li>
                  <li className="text-color-38 font-size-14 line-height-18">Email</li>
                </ul>
              </Grid>

              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 mb-0 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">Teléfono Celular</li>
                  <li className="text-color-38 font-size-14 line-height-18">Dirección Particular</li>
                  <li className="text-color-38 font-size-14 line-height-18">Declaración Ley Fatca</li>
                  <li className="text-color-38 font-size-14 line-height-18">Validación de Identidad</li>
                  <li className="text-color-38 font-size-14 line-height-18">Monto cuota de participación</li>
                  <li className="text-color-38 font-size-14 line-height-18">Encuesta de preferencias</li>
                </ul>
              </Grid>
            </Grid>

            <p className="mb-2 mt-3 font-size-14 line-height-20 font-weight-bold">Cómo serán tratados tus datos:</p>

            <Grid row className="m-0 p-0">
              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 margin-bottom-4 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">
                    Materializar y ejecutar la contratación de productos o servicios de tu elección.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Ser utilizados para fines estadísticos internos de Coopeuch.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Revisar vigencia de tu cédula identidad y realizar consultas con el registro civil.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Realizar elaboración de perfiles y riesgos en relación a morosidades o protestos.
                  </li>
                </ul>
              </Grid>

              <Grid col={12} md={6} className="m-0 p-0 pl-4">
                <ul className="margin-top-4 mb-0 vineta-circle">
                  <li className="text-color-38 font-size-14 line-height-18">Realizar consultas a fuentes externas.</li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Realizar consultas sobre tus últimas cotizaciones previsionales.
                  </li>
                  <li className="text-color-38 font-size-14 line-height-18">Coordinar la entrega de tus productos.</li>
                  <li className="text-color-38 font-size-14 line-height-18">
                    Enviar información de carácter comercial ofreciéndote nuevos incentivos, beneficios, productos o
                    servicios que se ajusten a tus necesidades.
                  </li>
                </ul>
              </Grid>
            </Grid>

            <p className="font-size-14 line-height-20 mt-3">
              Sin perjuicio de lo anterior, podrás disponer en todo momento de los derechos de información,
              modificación y cancelación de tus datos personales y los demás que establece la Ley 19.628 “Sobre
              Protección de la Vida Privada”, o la ley que la reemplace y/o modifique en el futuro.
            </p>
          </Grid>

          <Grid className="m-0 p-0 py-5 px-4 d-flex justify-content-center align-items-center border-top border-neutral-alfa-15 flex-0-1-auto">
            <StyledButton variant="default" disabled={false} onClick={closeModal} color="secondary" className="text-align-center">
              Entendido
            </StyledButton>
          </Grid>
        </section>
      </Modal>

      <Modal isOpen={isOpenModalCedule} closeModal={closeModalCedule} closeClickOutside closeEscKey>
        <ContentSerialNumber onClickButton={closeModalCedule} />
      </Modal>
    </>
  );
};

/* istanbul ignore next */
CardPersonValidation.defaultProps = {
  rut: {},
  serialNumber: {},
  badSerialNumber: false,
  isValidPerson: false,
  isLoadingValidatePersonalData: false,
  onValidatePerson: () => null,
  onChange: () => null,
};
/* istanbul ignore next */
CardPersonValidation.propTypes = {
  rut: PropTypes.shape({
    value: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.shape()),
  }),
  serialNumber: PropTypes.shape({
    value: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.shape()),
  }),
  badSerialNumber: PropTypes.bool,
  isValidPerson: PropTypes.bool,
  isLoadingValidatePersonalData: PropTypes.bool,
  onValidatePerson: PropTypes.func,
  onChange: PropTypes.func,
};

export default CardPersonValidation;